export const isDocumentPipSupported = (): boolean =>
  typeof window !== "undefined" && Boolean(window.documentPictureInPicture);

const copyStyles = (target: Document): void => {
  document.querySelectorAll('link[rel="stylesheet"], style').forEach((node) => {
    target.head.appendChild(node.cloneNode(true));
  });
};

export const openDocumentPip = async (width: number, height: number): Promise<Window | null> => {
  const pip = window.documentPictureInPicture;
  if (!pip) return null;
  try {
    const pipWindow = await pip.requestWindow({ width, height, preferInitialWindowPlacement: true });
    copyStyles(pipWindow.document);
    return pipWindow;
  } catch {
    return null;
  }
};
